export default __webpack_public_path__ + "static/media/velocy-express.d5bc1396.png";